import AbstractUISlider from "./AbstractUISlider";
import Wallet from "../../../wallet/Wallet";
import {ELEMENT_IDS} from "../MobileDOM";
import {ACTION_EVENTS} from "../../UserAction";
import events from "../../../events/EventsObservable";

export default class UISliderBets extends AbstractUISlider {

    constructor(wallet: Wallet) {

        let slider = document.getElementById(ELEMENT_IDS.SLIDER_BET);
        let value = wallet.getCreditBet();
        let allowedValues = wallet.getAllowedCreditBets();
        let range = wallet.getCreditBets();

        super(wallet, slider, range, value, allowedValues);
        events.subscribe(ACTION_EVENTS.ACTION_SLIDER_BET_ON_SET, this);
        events.subscribe(ACTION_EVENTS.ACTION_SLIDER_BET_UPDATE, this);
    }

    notify(eventName: string, data?: any, prevData?: any): Promise<any>|void {
        switch (eventName) {
            case ACTION_EVENTS.ACTION_SLIDER_BET_ON_SET:
                this._onSetEvent();
                break;
            case ACTION_EVENTS.ACTION_SLIDER_BET_UPDATE:
                this.__update(data.creditBet, data.allowedCreditBets);
                break;
        }
    }

    _update({creditBet, allowedCreditBets, coinValue, allowedCoinValues}) {
        this.__update(creditBet, allowedCreditBets);
        events.dispatch(ACTION_EVENTS.ACTION_SLIDER_COIN_UPDATE, {coinValue, allowedCoinValues});
    }
}